import { render, staticRenderFns } from "./ProductSpecificationsContent.vue?vue&type=template&id=c0d36fb2&scoped=true&"
import script from "./ProductSpecificationsContent.vue?vue&type=script&lang=js&"
export * from "./ProductSpecificationsContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductSpecificationsContent.vue?vue&type=style&index=0&id=c0d36fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d36fb2",
  null
  
)

export default component.exports